import React, { Fragment } from 'react';
import KeybordDatePicker from '../../Reusable/KeyboardDatePicker';

const DatePickerDemo = () => {
  const onDateChangeHandler = (value, name) => {};

  return (
    <Fragment>
      <KeybordDatePicker
        name="date-Field"
        label={'Date'}
        onChange={onDateChangeHandler}
      />
      <KeybordDatePicker
        name="date-field-positioned"
        label={'Date positioned'}
        onChange={onDateChangeHandler}
        placement="bottom"
      />
    </Fragment>
  );
};

export default DatePickerDemo;
